export const botMessageType = 'bot';
export const selfMessageType = 'self';

export function createMessagePayload({
    userId,
    senderType,
    type,
    messageId,
    message,
    data,
    slots, metadata
}) {
    return {
        userId,
        senderType,
        type,
        messageId,
        message,
        data,
        slots,
        metadata
    }
}

export function createSelfMessagePayload(inputText) {
    return createMessagePayload({
        senderType: selfMessageType,
        type: "text",
        messageId: "user",
        message: inputText,
    })
}

export function createBotMessagePayload(message) {

    // if message is received as unsupported format
    if (!message.type) {
        message = {
            type: 'default',
            content: message,
            metadata: {}
        }
    }

    return createMessagePayload({
        senderType: botMessageType,
        type: message.type,
        messageId: "bot",
        message: message.content,
        metadata: message.metadata
    })
}

/** The handle of a PAGINATED message, which a page turn sends back. */
export function paginationHandleOf(payload) {
    return payload?.type === 'PAGINATED' ? payload.metadata?.pagination?.handle : undefined;
}

/**
 * Add a bot message to the conversation.
 *
 * A page of a PAGINATED message replaces the message with the same handle, in
 * place, so paging through a table does not stack a copy of it per page. The
 * same rule collapses the pages stored in a replayed history.
 */
export function mergeBotMessage(messages, payload) {
    const handle = paginationHandleOf(payload);
    if (handle) {
        const index = messages.findIndex(message => paginationHandleOf(message) === handle);
        if (index !== -1) {
            const next = [...messages];
            next[index] = payload;
            return next;
        }
    }
    return [...messages, payload];
}
